function r(m) {
  if (document.querySelector(`script[src="${m}"]`))
    return;
  const t = document.createElement("script");
  t.src = m, t.async = !0, t.type = "module", document.head.appendChild(t);
}
function i(m, t) {
  for (const [o, e] of Object.entries(t))
    e != null && m.setAttribute(o, e.toString());
}
const b = {
  loaded: !0,
  "comment:published": !0,
  "comment:edited": !0,
  "comment:deleted": !0,
  "comment:voted": !0,
  "comment:flagged": !0,
  reaction: !0,
  rating: !0,
  "auth:login:clicked": !0,
  "profile:clicked": !0
}, y = Object.keys(b);
function C(m, t, o) {
  r("https://talk.hyvor.com/embed/embed.js"), customElements.whenDefined("hyvor-talk-comments").then(() => {
    const e = document.createElement("hyvor-talk-comments");
    for (const [n, c] of Object.entries(m))
      c !== void 0 && (n === "settings" || n === "translations" ? e[n] = c : e.setAttribute(n, c));
    y.forEach((n) => {
      e.addEventListener(n, (c) => {
        o(n, c.detail);
      });
    }), t.innerHTML = "", t.appendChild(e);
  });
}
function k(m = {}, t = null) {
  customElements.whenDefined("hyvor-talk-comment-count").then(() => {
    window.hyvorTalkCommentCounts.load(m, t);
  });
}
function g(m) {
  r("https://talk.hyvor.com/embed/comment-counts.js"), m.loading !== "manual" && k();
}
const v = [
  "loaded",
  "comment:published",
  "comment:edited",
  "comment:deleted",
  "comment:voted",
  "comment:flagged",
  "reaction",
  "rating",
  "auth:login:clicked",
  "profile:clicked"
];
class u {
  static script(t) {
    t = t || "https://talk.hyvor.com", r(`${t}/embed/embed.js`);
  }
  static comments(t, o, e) {
    u.script(t.instance);
    const n = document.createElement("hyvor-talk-comments");
    for (let [c, s] of Object.entries(t))
      if (s != null) {
        if (c === "translations" && typeof s == "object") {
          for (let [d, f] of Object.entries(s))
            d = d.replace("_", "-"), n.setAttribute(`t-${d}`, f);
          continue;
        }
        c === "settings" && (s = JSON.stringify(s)), n.setAttribute(c, s);
      }
    return e && v.forEach((c) => {
      n.addEventListener(c, (s) => {
        e(c, s.detail);
      });
    }), o.appendChild(n), n;
  }
}
const a = "https://talk.hyvor.com";
class l {
  static script(t) {
    t = t || a, r(`${t}/embed/comment-counts.js`);
  }
  static commentCount(t, o) {
    l.script(t.instance);
    const e = document.createElement("hyvor-talk-comment-count");
    return i(e, t), o.appendChild(e), e;
  }
  static load(t = {}, o = null) {
    l.script(), customElements.whenDefined("hyvor-talk-comment-count").then(() => {
      window.hyvorTalkCommentCounts.load(t, o);
    });
  }
}
class h {
  static script(t) {
    t = t || a, r(`${t}/embed/newsletter.js`);
  }
  static form(t, o) {
    h.script(t.instance);
    const e = document.createElement("hyvor-talk-newsletter");
    return i(e, t), o.appendChild(e), e;
  }
}
const E = [
  "loaded",
  "subscription:created",
  "subscription:success",
  "subscription:updated"
];
class p {
  static script(t) {
    t = t || a, r(`${t}/embed/memberships.js`);
  }
  static memberships(t, o, e) {
    p.script(t.instance);
    const n = document.createElement("hyvor-talk-memberships");
    return i(n, t), e && E.forEach((c) => {
      n.addEventListener(c, (s) => {
        e(c, s.detail);
      });
    }), o = o || document.body, o.appendChild(n), n;
  }
  static gatedContent(t, o) {
    const e = document.createElement("hyvor-talk-gated-content");
    return i(e, t), o.appendChild(e), e;
  }
}
export {
  v as COMMENTS_EVENTS,
  l as CommentCounts,
  u as Comments,
  E as MEMBERSHIPS_EVENTS,
  p as Memberships,
  h as Newsletters,
  g as addCommentCounts,
  C as addComments,
  y as eventNames,
  k as loadCommentCounts
};
